import PublicSearchResultCard from '@/components/public/PublicSearchResultCard/PublicSearchResultCard.vue';
import RadioToggle from '@/components/ui/RadioToggle/RadioToggle.vue';

export default {
  name: 'PublicSearchToolbar',
  components: {
    PublicSearchResultCard,
    RadioToggle,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: null,
    },
    ariaLabel: {
      type: String,
      default: null,
    },
    submitLabel: {
      type: String,
      default: null,
    },
    filters: {
      type: Array,
      default: () => [],
    },
    activeFilters: {
      type: Array,
      default: () => [],
    },
    filterCounts: {
      type: Object,
      default: () => ({}),
    },
    scopeOptions: {
      type: Array,
      default: () => [],
    },
    activeScope: {
      type: String,
      default: '',
    },
    hints: {
      type: Array,
      default: () => [],
    },
    showHints: {
      type: Boolean,
      default: false,
    },
    results: {
      type: Array,
      default: () => [],
    },
    resultsCount: {
      type: Number,
      default: null,
    },
    showDropdownResults: {
      type: Boolean,
      default: false,
    },
    showResultsPanel: {
      type: Boolean,
      default: false,
    },
    moreRoute: {
      type: [String, Object],
      default: null,
    },
    moreLabel: {
      type: String,
      default: null,
    },
    emptyText: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue', 'update:activeFilters', 'update:activeScope', 'submit'],

  computed: {
    resolvedPlaceholder() {
      return this.placeholder || this.$t('search.publicPlaceholder');
    },

    resolvedAriaLabel() {
      return this.ariaLabel || this.$t('search.search');
    },

    resolvedSubmitLabel() {
      return this.submitLabel || this.$t('search.find');
    },

    resolvedMoreLabel() {
      return this.moreLabel || this.$t('search.showAll');
    },

    resolvedEmptyText() {
      return this.emptyText || this.$t('search.noResults');
    },

    totalResultsCount() {
      return this.resultsCount ?? this.results.length;
    },

    canShowMore() {
      return Boolean(this.moreRoute && this.totalResultsCount > this.results.length);
    },
  },

  methods: {
    updateSearchQuery(event) {
      this.$emit('update:modelValue', event.target.value);
    },

    submitSearch() {
      this.$emit('submit', this.modelValue.trim());
    },

    isFilterActive(type) {
      return this.activeFilters.includes(type);
    },

    getFilterCount(type) {
      return this.filterCounts[type] ?? 0;
    },

    getFilterLabel(filter) {
      return filter?.labelKey ? this.$t(filter.labelKey) : filter?.label;
    },

    getHintLabel(hint) {
      return hint?.labelKey ? this.$t(hint.labelKey) : hint?.label;
    },

    toggleFilter(type) {
      const nextFilters = this.isFilterActive(type)
        ? this.activeFilters.filter((activeType) => activeType !== type)
        : [...this.activeFilters, type];

      this.$emit('update:activeFilters', nextFilters);
    },

    setScope(scope) {
      this.$emit('update:activeScope', scope);
    },
  },
};
